<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "MasterTruckLumpsumIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
